<div class="segment-modal">
  <p class="text segment-modal__text">
    Пожалуйста, опишите сегмент, который вы планируете использовать в рекламной кампании. Укажите
    особенности продвигаемого продукта и цели кампании — эта информация поможет нам более точно
    сформировать индивидуальный сегмент.
  </p>

  <form class="form" [formGroup]="segmentForm" tuiForm>
    <!--Platform-->
    <label tuiLabel tuiAppearance="ai-label">
      <span class="ai-label">Площадка</span>

      @let platformControl = segmentForm.controls.platform;

      <tui-textfield tuiChevron>
        <input
          tuiComboBox
          placeholder="Введите название площадки"
          formControlName="platform"
        />

        <tui-data-list-wrapper
          *tuiTextfieldDropdown
          new
          emptyContent="Ничего не найдено"
          [items]="context.data.platforms | tuiFilterByInput"
        />
      </tui-textfield>
    </label>

    @if (platformControl.touched) {
      @if (platformControl.hasError('required')) {
        <tui-error error="Это поле не может быть пустым"></tui-error>
      }
    }
    <!--Platform-->

    <!--Comment-->
    <label tuiLabel tuiAppearance="ai-label">
      <span class="ai-label">Комментарий</span>

      @let commentControl = segmentForm.controls.comment;

      <tui-textfield class="form__textarea">
        <textarea
          class="form__textarea"
          [min]="0"
          [max]="0"
          formControlName="comment"
          placeholder="Напишите все, что считаете важным для вашего запроса"
          tuiTextarea
        ></textarea>
      </tui-textfield>
    </label>

    @if (commentControl.touched) {
      @if (commentControl.hasError('required')) {
        <tui-error error="Это поле не может быть пустым"></tui-error>
      }
    }
    <!--Comment-->

    <footer>
      <button
        class="button"
        [loading]="segmentModalStore.isLoading()"
        [disabled]="!segmentForm.valid"
        (click)="buildAudience()"
        type="button"
        tuiButton
        appearance="ai-primary"
        size="m"
      >
        Отправить
      </button>
    </footer>
  </form>
</div>
